<template>
            <main class="main">
            <!-- Content Header (Page header) -->
            <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                <div class="col-sm-6">
                    
                    <h1 class="m-0 text-dark">Traslado Entrada</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    
                </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
            </div>
            <div class="container-fluid">
                <!-- Ejemplo de tabla Listado -->
                <div class="card">

                   
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Traslados
                      
                        
                        <!--
                        <button type="button" @click.prevent="validarUser()" class="btn btn-success">
                            <i class="fas fa-plus-square"></i>&nbsp;Validar
                        </button>
                       -->
                    </div>
                    <!------------------------------------------------- Listado Principal ------------------------------>
                    <template v-if="listado==1">
                    <div class="card-body">
                        <div class="form-group row">
                            <div class="col-md-6">
                                
                             
                                <div class="input-group">

                                    <select class="form-control col-md-3" v-model="criterio">
                                      
                                      <option value="fecha_hora">Fecha-Hora</option>
                                      <option value="numerotraslado">Numerotraslado</option>
                                    </select>
                                    <input type="text" v-model="buscar" @keyup.enter="listarTraslado(1,buscar,criterio)" class="form-control" placeholder="Texto a buscar">
                                    <button type="submit" @click="listarTraslado(1,buscar,criterio)" class="btn btn-primary"><i class="fa fa-search"></i> Buscar</button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Opciones</th>
                                        <th>Numero Traslado</th>
                                        <th>Usuario</th>
                                        <th>Encargado</th>
                                        <th>Recibe</th>
                                        <th>Fecha_hora</th>
                                        <th>Origen</th>
                                        
                                        <th>Estado</th>
                                       
                                      
                                        
                                    
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(traslado,index) in arrayTraslado" :key="traslado.id">
                                        <td>
                                            {{(index+1)}}
                                        </td>
                                        <td>
                                            <template v-if="traslado.estado=='1'">
                                                
                                                <button type="button" @click.prevent="verTraslado(traslado.id)" class="btn btn-success btn-sm">
                                                <i class="fas fa-eye"></i>
                                                </button> &nbsp;
                                                 <button type="button" @click.prevent="pdfTraslado(traslado.id)" class="btn btn-info btn-sm">
                                                 <i class="fas fa-file-pdf"></i>
                                                </button> &nbsp;
                                               <button type="button" @click.prevent="agregarETraslado(traslado.id,traslado.numerotraslado,traslado.total)" class="btn btn-success btn-sm">
                                                <i class="fas fa-check-circle"></i>
                                               </button>
                                               
                                            </template>
                                            <template v-if="traslado.estado=='2'">
                                               
                                                <button type="button" @click.prevent="verTraslado(traslado.id)" class="btn btn-success btn-sm">
                                                <i class="fas fa-eye"></i>
                                                </button> &nbsp;
                                                
                                            </template>
                                            <template v-if="traslado.estado=='3'">
                                               
                                                <button type="button" @click.prevent="verTraslado(traslado.id)" class="btn btn-success btn-sm">
                                                <i class="fas fa-eye"></i>
                                                </button> &nbsp;
                                                
                                            </template>
                                           
                                          
                                            
                                        </td>
                                        <td v-text="traslado.numerotraslado"></td>
                                        <td v-text="traslado.usuario"></td>
                                        <td v-text="traslado.encargado"></td>
                                        <td v-text="traslado.recibe"></td>
                                        <td v-text="traslado.fecha_hora"></td>
                                        <td v-text="traslado.origen"></td>
                                        
                                        <td>
                                        <div v-if="traslado.estado=='1'">
                                           <span class="badge badge-warning"> Pendiente</span>
                                        </div>
                                        <div v-if="traslado.estado=='2'">
                                           <span class="badge badge-success"> Finalizado</span>
                                        </div>
                                        
                                    </td>
                                        
                                       
                                       
                                        
                                       
                                        
                                    </tr>                                
                                </tbody>
                            </table>
                        </div>
                        <nav>
                            <ul class="pagination">
                                <li class="page-item" v-if="pagination.current_page > 1">
                                    <a class="page-link" href="#" @click.prevent="cambiarPagina(pagination.current_page - 1,buscar,criterio,idlugar)">Ant</a>
                                </li>
                                <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                    <a class="page-link" href="#" @click.prevent="cambiarPagina(page,buscar,criterio,idlugar)" v-text="page"></a>
                                </li>
                                <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                    <a class="page-link" href="#" @click.prevent="cambiarPagina(pagination.current_page + 1,buscar,criterio,idlugar)">Sig</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    </template>
                    <!--Fin Listado-->

                <!------------------------------------------------- Detalle ------------------------------>
                    <template v-else-if="listado==0">
                    <div class="card-body">
                        <div class="form-group row border">
                           
                            
                        
                            <div class="col-md-12">
                                <div v-show="errorTraslado" class="form-group row div-error">
                                    <div class="text-center text-error">
                                        <div v-for="error in errorMostrarMsjTraslado" :key="error" v-text="error">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="form-group row border">
                             <!--
                             <div class="col-md-9">
                                 <div class="form-group">
                                       <label for="exampleFormControlSelect1">Origen <span style="color:red;" v-show="idlugar==0">(*Seleccione)</span></label>
                                       <select class="form-control" id="exampleFormControlSelect1" v-model="idlugar">
                                         <option value="0" >Seleccione</option>
                                          <option v-for="lugar in arrayLugar" :key="lugar.id" :value="lugar.id" v-text="lugar.nombre"></option>
                                        </select>
                                     </div>
                             </div>
                             -->
                             <div class="col-md-9">
                                 <div class="form-group">
                                       <label for="exampleFormControlSelect1">Destino <span style="color:red;" v-show="idlugar2==0">(*Seleccione)</span></label>
                                       <select class="form-control" id="exampleFormControlSelect1" @change="onChange($event)" v-model="idlugar2">
                                         <option value="0" >Seleccione</option>
                                          <option v-for="lugar in arrayLugar2" :key="lugar.id" :value="lugar.id" v-text="lugar.nombre"></option>
                                        </select>
                                     </div>
                             </div>
                             <div class="col-md-4">
                                <div class="form-group">
                                    <label>Encargado</label>
                                    <input type="text" v-model="encargado">
                                </div>
                            </div>
                             
                        </div>   
                        <div class="form-group row border">
                            <div class="col-md-9">
                                <div class="form-group">
                                    <label>Producto <span style="color:red;" v-show="idproducto==0">(*Seleccione)</span></label>
                                    <div class="form-inline">
                                        <button @click.prevent="abrirModal()" class="btn btn-primary"><i class="fas fa-search-plus"></i></button>
                                         <input  v-on:keyup.enter="buscarProducto2()" v-model="codigo" type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
                                    </div>    
                                                                
                                </div>
                            </div>
                           
                        </div>
                        <div class="col-md-4">
                                <div class="form-group">
                                    <label>Total Articulos</label>
                                    <p>{{totalArticulo}}</p>
                                </div>
                            </div>

                        <div class="form-group row border">
                            <div class="table-responsive-md col-md-12">
                                <table  class="table table-bordered table-striped ">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Opciones</th>
                                            <th>Codigo</th>
                                            <th>Producto</th>
                                            
                                           
                                            <th>Cantidad</th>
                                            
                                            
                                           
                                        </tr>
                                    </thead>
                                    <tbody v-if="arrayDetalle.length">
                                        <tr v-for="(detalle,index) in arrayDetalle" :key="detalle.id">
                                            <td>
                                                {{(index+1)}}
                                            </td>
                                            <td>
                                                <button @click="eliminarDetalle(index)" type="button" class="btn btn-danger btn-sm">
                                                    <i class="fas fa-times-circle"></i>
                                                </button>
                                            </td>
                                            <td v-text="detalle.codigo">
                                            </td>
                                            <td v-text="detalle.producto">
                                            </td>
                                             
                                            <td>
                                                
                                                <input style="width: 100px" v-model="detalle.precio" type="number" value="3" class="form-control" >
                                            </td>
                                            <td>
                                                 <span style="color:red;" v-show="(detalle.stock < detalle.cantidad)">Cantidad Mayor al Stock</span>
                                                <input v-model.number="detalle.cantidad"  type="number" value="2" class="form-control">
                                            </td>
                                            
                                            
                                             
                                        </tr>
                                    
                                        
                                        
                                    </tbody>
                                    


                                    
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="5">
                                                NO hay productos agregados
                                            </td>
                                        </tr>
                                    </tbody>                                    
                                </table>

                                <!--  ---------  Tabla cotizar ----------->
                                
                                 <table id="producto"  v-show="cotizar" class="table table-bordered table-striped ">
                                    
                                    
                                    <thead>
                                        <tr>
                                           <th>No</th>
                                            <th>Producto</th>
                                            
                                            
                                            <th>Cantidad</th>
                                            
                                          
                                            
                                        </tr>
                                    </thead>
                                    <tbody v-if="arrayDetalle.length">
                                        <tr v-for="(detalle,index) in arrayDetalle" :key="detalle.id">
                                            <td>{{(index+1)}}</td>
                                            <td v-text="detalle.producto"></td>
                                           
                                            
                                            <td v-text="detalle.cantidad"></td>
                                           
                                            <td>
                                               Q {{detalle.precio*detalle.cantidad-detalle.descuento}}
                                            </td>
                                           
                                        </tr>
                                    
                                       
                                        
                                        
                                        
                                    </tbody>


                                    
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="5">
                                                NO hay productos agregados
                                            </td>
                                        </tr>
                                    </tbody>                                    
                                </table>
                                
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-12">
                               
                               
                                     <button type="button"  class="btn btn-primary" :disabled = "deshabilitar_boton==1"  @click="registrarTraslado()">Registrar Traslado</button>
                                     
                                     <button type="button" @click="ocultarDetalle()" class="btn btn-secondary">Cerrar</button>
                              
                                
                            </div>
                        </div>
                    </div>
                    </template>
                    <!-- Fin Detalle-->

                    <!------------------------------------------------- Ver Traslado_detalle ------------------------------>
                    <template v-else-if="listado==2">
                    <div class="card-body">
                        <div class="form-group row border">
                            
                           
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Origen</label>
                                    <p v-text="origen"></p>
                                </div>
                            </div>
                            
                            
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Total Articulos</label>
                                    <p>{{totalArticulo}}</p>
                                </div>
                            </div>

                            
                            
                        </div>
                        <div class="form-group row border">
                            <div class="table-responsive col-md-12">
                                
                                <table class="table table-bordered table-striped table-sm">

                                    <thead>
                                        <tr>
                                            
                                                
                                           
                                            <th>No</th>
                                            <th>Codigo</th>
                                            <th>Categoria</th>
                                            <!--
                                            <th>Genero</th>
                                            <th>Diseño</th>
                                            <th>Tela</th>
                                            <th>Color</th>
                                            <th>Talla</th>
                                            <th>Lote</th>
                                            -->
                                            <th>Producto</th>
                                           
                                            
                                            <th>Cantidad</th>
                                            
                                            
                                            
                                            
                                            
                                        </tr>
                                    </thead>
                                    <tbody v-if="arrayDetalle.length">
                                        <tr v-for="(detalle,index) in arrayDetalle" :key="detalle.id">
                                            <td>
                                                {{(index+1)}}
                                            </td>

                                            <td v-text="detalle.codigo">
                                            </td>
                                           <td v-text="detalle.categoria">
                                            </td>
                                            <!--
                                           <td v-text="detalle.genero">
                                            </td>
                                           <td v-text="detalle.diseno">
                                            </td>
                                           <td v-text="detalle.tela">
                                            </td>
                                           <td v-text="detalle.color">
                                            </td>
                                           <td v-text="detalle.talla">
                                            </td>
                                           <td v-text="detalle.lote">
                                            </td>
                                            -->
                                            <td v-text="detalle.articulo">
                                            </td>
                                           
                                           
                                           
                                            <td v-text="detalle.cantidad">
                                            </td>
                                            
                                          
                                            
                                        </tr>
                                       
                                        <!--
                                        <tr style="background-color: #CEECF5;">
                                            <td colspan="3" align="right"><strong>Total Parcial:</strong></td>
                                            <td>Q {{totalParcial=(total-totalImpuesto).toFixed(2)}}</td>
                                        </tr>
                                        -->
                                        <!--
                                        <tr style="background-color: #CEECF5;">
                                            <td colspan="3" align="right"><strong>Total Impuesto:</strong></td>
                                            <td>Q {{totalImpuesto=((total*impuesto)).toFixed(2)}}</td>
                                        </tr>
                                    -->
                                    <!--
                                        <tr style="background-color: #CEECF5;">
                                            <td colspan="3" align="right"><strong>Total Neto:</strong></td>
                                            <td >Q <span id="totalTrasladoArticulo">{{total}}</span> </td>
                                        </tr>
                                        -->
                                        
                                       
                                       
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4">
                                                NO hay productos agregados
                                            </td>
                                        </tr>
                                    </tbody>                                    
                                </table>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-12">
                                <button type="button" @click="ocultarDetalle()" class="btn btn-secondary">Cerrar</button>
                                
                            </div>
                        </div>
                    </div>
                    </template>
                    <!-- fin ver traslado -->
                </div>
                <!-- Fin ejemplo de tabla Listado -->
            </div>

   <!------------------------------------------------- Modal agregar ------------------------------>

            <div class="modal fade p-5" tabindex="-1" :class="{'mostrar' : modal}" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                <div class="modal-dialog modal-primary modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" v-text="tituloModal"></h4>
                            <button type="button" class="close" @click.prevent="cerrarModal()" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group row">
                                <div class="col-md-6">
                                    
                                    <div class="input-group">
                                        
                                        <select class="form-control col-md-3" v-model="criterioA">
                                        <option value="codigo">Codigo</option>    
                                        <option value="nombre">Nombre</option>
                                        <option value="descripcion">Descripción</option>
                                        </select>
                                        <input type="text" v-model="buscarA" @keyup.enter="listarProducto(1,buscarA,criterioA,idlugar)" class="form-control" placeholder="Texto a buscar">
                                        <button type="submit" @click="listarProducto(1,buscarA,criterioA,idlugar)" class="btn btn-primary"><i class="fa fa-search"></i> Buscar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th>Opciones</th>
                                            <th>Categoria</th>
                                            <th>Codigo</th>
                                            <th>Nombre</th>
                                            <th>Descripcion</th>
                                            <!--<th>Stock</th>-->
                                            
                                            <th>Estado</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="producto in arrayProducto" :key="producto.id">
                                            <td>
                                                <button type="button" @click.prevent="agregarDetalleModal(producto)" class="btn btn-success btn-sm">
                                                <i class="fas fa-check-circle"></i>
                                                </button>
                                            </td>
                                           <td v-text="producto.nombre_categoria"></td>
                                           <td v-text="producto.codigo"></td>
                                            <td v-if="producto.stock <= producto.minimo" class="bg-danger" v-text="producto.nombre"></td>
                                            <td v-else v-text="producto.nombre"></td>
                                             <td v-text="producto.descripcion"></td>
                                            <!-- <td v-text="producto.stock"></td> -->
                                           
                                            
                                            <td>
                                                <div v-if="producto.condicion">
                                                    <span class="badge badge-success">Activo</span>
                                                </div>
                                                <div v-else>
                                                    <span class="badge badge-danger">Desactivado</span>
                                                </div>
                                                
                                            </td>  
                                           
                                        </tr>      
                                                                
                                    </tbody>
                                </table>
                                <nav>   
                                <ul class="pagination pagination-sm m-0 float-right">
                                <li class="page-item" v-if="pagination2.current_page > 1">
                                    <a class="page-link" href="#" @click="cambiarPagina2(pagination2.current_page - 1,buscarA,criterioA,idlugar)" >&laquo;</a>
                                </li>
                                <li class="page-item" v-for="page in pagesNumber2" :key="page" :class="[page == isActived2 ? 'active' : '']">
                                    <a class="page-link" href="#" @click="cambiarPagina2(page,buscarA,criterioA,idlugar)" v-text="page"></a>
                                    </li>
                                <li class="page-item" v-if="pagination2.current_page < pagination2.last_page">
                                    <a class="page-link" href="#" @click="cambiarPagina2(pagination2.current_page + 1,buscarA,criterioA,idlugar)">&raquo;</a>
                                    </li>
                                </ul>
                                </nav>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                            
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--Fin del modal-->




            <div tabindex="-1" class="modal fade p-5" :class="{'mostrar' : modal2}" >
        <div class="modal-dialog modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h4 class="modal-title" v-text="tituloModal2"></h4>
              <button type="button" class="close" @click="cerrarModal()" >
                <span aria-hidden="true" class="text-white">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                   <div class="card-body table-responsive">
                <table  class="table table-bordered table-striped">
                  <thead>
                  <tr>

                   
                    <th>Nombre</th>
                    <th>Stock</th>
                    <th>Descripcion</th>
                    <th>Minimo</th>
                    
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="producto in arrayProducto" :key="producto.id" >
                    
                                    
                                    <td v-if="producto.stock <= producto.minimo"  v-text="producto.nombre"></td>  
                                    <td v-if="producto.stock <= producto.minimo" class="bg-danger" v-text="producto.stock"></td>  
                                    <td v-if="producto.stock <= producto.minimo" v-text="producto.descripcion"></td>
                                    <td v-if="producto.stock <= producto.minimo" class="bg-danger" v-text="producto.minimo"></td>
                                 

                                
                 
                  </tr>
                 
                  
                  </tbody>
                  <tfoot>
                  
                  </tfoot>
                </table>
                <div class="card-footer clearfix">
                 <nav>   
                <ul class="pagination pagination-sm m-0 float-right">
                  <li class="page-item" v-if="pagination.current_page > 1">
                    <a class="page-link" href="#" @click="cambiarPagina(pagination.current_page - 1,buscar,criterio,idlugar2)" >&laquo;</a>
                 </li>
                  <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                    <a class="page-link" href="#" @click="cambiarPagina(page,buscar,criterio,idlugar2)" v-text="page"></a>
                    </li>
                  <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                    <a class="page-link" href="#" @click="cambiarPagina(pagination.current_page + 1,buscar,criterio,idlugar2)">&raquo;</a>
                    </li>
                </ul>
                </nav>
              </div>
            </div>
                
            </div>
            <div class="modal-footer ">
              <button type="button" class="btn btn-default"  @click="cerrarModal()">Close</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->




             <!------------------------------------------------- Modal Cliente ------------------------------>
   
            <div class="modal fade p-5" tabindex="-1" :class="{'mostrar' : modalB}" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                <div class="modal-dialog modal-primary modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" v-text="tituloModalB"></h4>
                            <button type="button" class="close" @click="cerrarModalB()" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group row">
                                <div class="col-md-6">
                                    <div class="input-group">
                                        <select class="form-control col-md-3" v-model="criterioB">
                                        <option value="nit">Nit</option>
                                        <option value="nombre">Nombre</option>
                                        
                                        </select>
                                        <input type="text" v-model="buscarB" @keyup.enter="listarCliente(buscarB,criterioB)" class="form-control" placeholder="Texto a buscar">
                                        <button type="submit" @click="listarCliente(buscarB,criterioB)" class="btn btn-primary"><i class="fa fa-search"></i> Buscar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table  class="table table-bordered table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th>Opciones</th>
                                            <th>Nit</th>
                                            <th>Nombre</th>
                                            <th>Direccion</th>
                                            <th>Telefono</th>
                                             <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="cliente in arrayCliente" :key="cliente.id">
                                            <td>
                                                <button type="button" @click.prevent="agregarClienteModal(cliente)" class="btn btn-success btn-sm">
                                                <i class="fas fa-check-circle"></i>
                                                </button>
                                            </td>
                                           
                                            <td v-text="cliente.nit"></td>
                                            <td v-text="cliente.nombre"></td>
                                            <td v-text="cliente.direccion"></td>
                                            <td v-text="cliente.telefono"></td>
                                            <td>
                                                <div v-if="cliente.condicion">
                                                    <span class="badge badge-success">Activo</span>
                                                </div>
                                                <div v-else>
                                                    <span class="badge badge-danger">Desactivado</span>
                                                </div>
                                                
                                            </td>
                                        </tr>                                
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="cerrarModalB()">Cerrar</button>
                            <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click.prevent="registrarCliente()">Guardar</button>
                            <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click.prevent="actualizarCliente()">Actualizar</button>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!--Fin del modal-->
        </main>
</template>

<script>
    
    
    export default {
        data (){
            return {
                traslado_id: 0,
                idcliente:0,
                idlugar:0,
                idlugar2:0,
                destino: '',
                origen:'',
                encargado: '',
                numerotraslado: '',
                nit: '',
                destinonombre: '',
                revisarestado: '',
                lugar:'',
                cotizar:0,
                cliente:'',
                codigo:'',
                nombre : '',
                nombrep : '',
                direccion : '',
                telefono : '',
                tipo_comprobante : 'TICKET',
                serie_comprobante : '',
                num_comprobante : '',
                estado : '',
                urlhttp: this.$api_url,
                deshabilitar_boton:0,
                impuesto: 0.0,
                total:0.0,
                totalc:0.0,
                totalu:0.0,
                recibido:0.0,
                totalImpuesto: 0.0,
                totalParcial: 0.0,
                arrayTraslado : [],
                arrayCliente: [],
                arrayDetalle : [],
                arrayLugar : [],
                 arrayLugar2 : [],
                 arraySucursal : [],
                 arrayAceptarT : [],
                listado:1,
                modal : 0,
                modalB : 0,
                 modal2 : 0,
                tituloModal : '',
                tituloModalB : '',
                 tituloModal2 : '',
                tipoAccion : 0,
                errorTraslado : 0,
                errorMostrarMsjTraslado : [],
                pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
                offset : 3,

                 pagination2 : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
                offset2 : 3,
                criterio : 'fecha_hora',
                buscar : '',
                criterioA:'nombre',
                buscarA: '',
                criterioB:'nombre',
                buscarB: '',
                arrayProducto: [],
                idproducto: 0,
               // codigo: '',
                producto: '',
                precio: 0,
                cantidad:0,
                descuento: 0,
                cambio: 0,
                negativo: 0,
                stock: 0
            }
        },
        components: {
            
        },
        computed:{
            isActived: function(){
                return this.pagination.current_page;
            },
            isActived2: function(){
                return this.pagination2.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if(!this.pagination.to) {
                    return [];
                }
                
                var from = this.pagination.current_page - this.offset; 
                if(from < 1) {
                    from = 1;
                }

                var to = from + (this.offset * 2); 
                if(to >= this.pagination.last_page){
                    to = this.pagination.last_page;
                }  

                var pagesArray = [];
                while(from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
            pagesNumber2: function() {
                if(!this.pagination2.to) {
                    return [];
                }
                
                var from = this.pagination2.current_page - this.offset2; 
                if(from < 1) {
                    from = 1;
                }

                var to = from + (this.offset2 * 2); 
                if(to >= this.pagination2.last_page){
                    to = this.pagination2.last_page;
                }  

                var pagesArray2 = [];
                while(from <= to) {
                    pagesArray2.push(from);
                    from++;
                }
                return pagesArray2;
            },
            calcularTotal: function(){
                var resultado=0.0;
                for(var i=0;i<this.arrayDetalle.length;i++){
                    
                    resultado=resultado+(this.arrayDetalle[i].precio*this.arrayDetalle[i].cantidad-this.arrayDetalle[i].descuento)
                }
                return resultado;
            },


            calcularTotalc: function(){
                var resultado=0.0;
                for(var i=0;i<this.arrayDetalle.length;i++){
                    
                    resultado=resultado+(this.arrayDetalle[i].costo*this.arrayDetalle[i].cantidad)
                }
                return resultado;
            },


            calcularTotalu: function(){
                var resultado=0.0;
                for(var i=0;i<this.arrayDetalle.length;i++){
                    
                    resultado=resultado+((this.arrayDetalle[i].precio*this.arrayDetalle[i].cantidad-this.arrayDetalle[i].descuento)-(this.arrayDetalle[i].costo*this.arrayDetalle[i].cantidad))
                }
                return resultado;
            },


            totalArticulo: function(){
                var result=0;
                 for(var i=0;i<this.arrayDetalle.length;i++){
                    
                    result+=(this.arrayDetalle[i].cantidad)
                }
                return result;


            },

            contarAlerta: function(){
              
              var resultado=0;
                for(var i=0;i<this.arrayProducto.length;i++){

                    if(this.arrayProducto[i].stock <= this.arrayProducto[i].minimo){

                      resultado +=1;
                    }
                    
                    
                }
                return resultado;
            }
        },
        methods : {


      /**************************************************************************************** */      
            listarTraslado (page,buscar,criterio){
                
                let me=this;
                var url= '/trasladove?page=' + page + '&buscar='+ buscar + '&criterio='+ criterio ;
                axios.get(url).then(function (response) {
                    console.log(response);
                    var respuesta= response.data;
                    me.arrayTraslado = respuesta.traslados.data;
                    me.pagination= respuesta.pagination;
                })
                .catch(function (error) {
                    console.log(error);
                });
                
            },

       /**************************************************************************************** */       
            buscarCliente(){
                let me=this;
              

                var url= '/cliente/selectCliente?filtro='+search;
                axios.get(url).then(function (response) {
                    let respuesta = response.data;
                    me.arrayCliente=respuesta.clientees;
                   
                })
                .catch(function (error) {
                    console.log(error);
                });
            },


                      onChange(event) {

              

              var destinonombre = event.target.options[event.target.options.selectedIndex].text;

              this.destinonombre = destinonombre;

             // console.log(destinonombre);

             

          },

        /**************************************************************************************** */      
            getDatosCliente(val1){
                let me = this;
                me.loading = true;
                me.idcliente = val1.id;
            },

         /**************************************************************************************** */     
            buscarProducto(){
                let me=this;
                var url= '/existencia/buscarProducto?filtro=' + me.nombre;

                axios.get(url).then(function (response) {
                    var respuesta= response.data;
                    me.arrayProducto = respuesta.productos;

                    if (me.arrayProducto.length>0){
                        me.producto=me.arrayProducto[0]['nombre'];
                        me.idproducto=me.arrayProducto[0]['id'];
                    }
                    else{
                        me.producto='No existe producto';
                        me.idproducto=0;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            buscarProducto2(){
                  let me=this;
                let idlugar = me.idlugar;
               var url= '/existencia/buscarProducto2?filtro=' + me.codigo + '&idlugar='+ idlugar;

               
                  
                axios.get(url).then(function (response) {

                    
                    var respuesta= response.data;
                    me.arrayProducto = respuesta.productos;

                  

                 

                    if (me.arrayProducto.length>0){
                        me.codigo=me.arrayProducto[0]['codigo'];
                        me.idproducto=me.arrayProducto[0]['id'];
                        me.nombre=me.arrayProducto[0]['nombre'];
                        me.costo=me.arrayProducto[0]['precio_costo'];
                        me.precio=me.arrayProducto[0]['precio_venta'];
                        me.stock= me.arrayProducto[0]['stock'];

                 if(me.encuentra(me.arrayProducto[0]['id']) ){
                          
                                                       for(var i=0;i<me.arrayDetalle.length;i++){
                    if(me.arrayDetalle[i].idproducto==me.idproducto){
                        me.arrayDetalle[i].cantidad= me.arrayDetalle[i].cantidad + 1;
                    }
                }

                    }else{
                        me.arrayDetalle.push({
                            idproducto: me.arrayProducto[0]['id'],
                            codigo: me.arrayProducto[0]['codigo'],
                            producto: me.arrayProducto[0]['nombre'],
                            cantidad: 1,
                            costo: me.arrayProducto[0]['precio_costo'],
                            precio: me.arrayProducto[0]['precio_venta'],
                            descuento: 0,
                            stock: me.arrayProducto[0]['stock'],
                        });
                    }


/*
                         if(me.arrayDetalle[i].idproducto==me.arrayProducto[0]['id']){

                             me.arrayDetalle.push({
                                 cantidad: cantidad+1
                                 });

                         }else{

                             me.arrayDetalle.push({
                            idproducto: me.arrayProducto[0]['id'],
                            codigo: me.arrayProducto[0]['codigo'],
                            producto: me.arrayProducto[0]['nombre'],
                            cantidad: 1,
                            costo: me.arrayProducto[0]['precio_costo'],
                            precio: me.arrayProducto[0]['precio_traslado'],
                            descuento: 0,
                            stock: me.arrayProducto[0]['stock'],
                        });

                         }               

                    */    


                        /*    
                         me.arrayDetalle.push({
                            idproducto: data['id'],
                            producto: data['nombre'],
                            cantidad: 1,
                            precio: data['precio_traslado'],
                            costo: data['precio_costo'],
                            descuento:0,
                            stock:data['stock']

                        }); 
                        */
                       /*
                        console.log(me.idproducto);
                        console.log(me.codigo);
                       console.log(me.nombre);
                       console.log(me.costo);
                       console.log(me.precio);
                       console.log(me.stock);
                       */
                    }
                    else{
                         me.arrayProducto = [];

                         me.codigo = "";
                        swal.fire({
                            type: 'error',
                            title: 'Error...',
                            text: 'No Existe el Codigo de Producto!',
                            })
                        
                        

                        
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
                
            },


         
          pdfTraslado(id){
                
                 window.open(this.urlhttp+'/traslado/pdf/'+id+','+'_blank');
                
            },

            

          /**************************************************************************************** */    

            cambiarPagina(page,buscar,criterio,idlugar2){
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.listarTraslado(page,buscar,criterio,idlugar);
            },

             cambiarPagina2(page,buscarA,criterioA,idlugar){
                let me = this;
                //Actualiza la página actual
                me.pagination2.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.listarProducto(page,buscarA,criterioA,idlugar);
            },

          /**************************************************************************************** */    
            encuentra(id){
                var sw=0;
                for(var i=0;i<this.arrayDetalle.length;i++){
                    if(this.arrayDetalle[i].idproducto==id){
                        sw=true;
                    }
                }
                return sw;
            },

          /**************************************************************************************** */    
            eliminarDetalle(index){
                let me = this;
                me.arrayDetalle.splice(index, 1);
            },

           desactivarTraslado(id,numerotraslado,total){

                 let me = this;

              
                 
                  axios.put('/traslado/estado',{

                    
                }).then(response => {
                    //console.log(response);
                  this.revisarestado = response.data;
                  console.log(this.revisarestado);
                  if(this.revisarestado===1){
                var urld= '/traslado/obtenerDetalles?id=' + id +'&numerotraslado='+numerotraslado;
                
                axios.get(urld).then(function (response) {
                    console.log(response);
                    var respuesta= response.data;
                    me.arrayAnularV = respuesta.detalles;
                    
                   
                  
                })
                .catch(function (error) {
                    console.log(error);
                });  
             
           
                   this.detallelist(id,numerotraslado,total);

                  }else{
                          
                          Swal.fire({
                             icon: 'error',
                             title: 'Oops...',
                             text: 'Este Traslado ya fue Aceptado No se Puede Ser Anulada!'
                           
                                })
                              me.listarTraslado(1,'','fecha_hora');

                  }
                })
                .catch(error => {
                   console.log(err);
                 });

                this.revisarestado="";
                 
            
                  
           
                },

        detallelist(id,numerotraslado,total){

               Swal.fire({
                title: 'Esta seguro/a que desea Anular este Traslado?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {

                  
                if (result.value) {
                  let me = this;
                  /*
                  console.log(total);
                      console.log(numerotraslado);
                      
                        console.log(id);
                        console.log(this.arrayAnularV);
*/
                        axios.put('/traslado/desactivar',{
                          'id': id,
                          'numerotraslado':numerotraslado,
                          'total':total,
                          
                          
                          'data': this.arrayAnularV
                          

                        }).then(function(response){
                          //  console.log(response);
                          me.listarTraslado(1,'','fecha_hora',);
                          me.arrayAnularV=[];
                           Swal.fire(
                            'Anulado!',
                            'El registro a sido desactivado con exito.',
                            'success'
                          )

                          
                        }).catch(function(error){
                          console.log(error);
                        });
                     
                 // console.log(this.arrayAnularV);
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                 
                }
              })

           },
          
          
           /**************************************************************************************** */   
            agregarDetalle(){
                let me=this;
                if(me.idproducto==0 || me.cantidad==0 || me.precio==0){
                }
                else{
                    if(me.encuentra(me.idproducto)){
                        
                         for(var i=0;i<this.arrayDetalle.length;i++){
                    if(me.arrayDetalle[i].idproducto==id){
                        me.arrayDetalle[i].cantidad++
                    }
                }
                        
                    }else{
                       me.arrayDetalle.push({
                            idproducto: me.idproducto,
                            codigo: me.codigo,
                            producto: me.producto,
                            cantidad: me.cantidad,
                            precio: me.precio,
                            costo: me.costo,
                            descuento: me.descuento,
                            stock: me.stock
                        });
                        me.codigo="";
                        me.idproducto=0;
                        me.producto="";
                        me.cantidad=0;
                        me.precio=0;
                        me.costo=0;
                        me.descuento=0;
                        me.stock=0 
                    }
                    
                }

                

            },

             /**************************************************************************************** */ 
            agregarDetalleModal(data =[]){
                
                let me=this;
                if(me.encuentra(data['id'])){


                               for(var i=0;i<me.arrayDetalle.length;i++){
                    if(me.arrayDetalle[i].idproducto==data['id']){
                        me.arrayDetalle[i].cantidad= me.arrayDetalle[i].cantidad + 1;
                    }
                }

                           
                    
                    }
                    else{
                       me.arrayDetalle.push({
                            idproducto: data['id'],
                             codigo: data['codigo'],
                            producto: data['nombre'],
                            cantidad: 1,
                            precio: data['precio_venta'],
                            costo: data['precio_costo'],
                            descuento:0,
                            stock:data['stock']

                        }); 
                    }
            },

            agregarDetalleModal2(data =[]){
                
                let me=this;
                if(me.encuentra(data['id'])){
                        swal.fire({
                            type: 'error',
                            title: 'Error...',
                            text: 'Ese producto ya se encuentra agregado!',
                            })
                    }
                    else{
                       me.arrayDetalle.push({
                            idproducto: data['id'],
                            codigo: data['codigo'],
                            producto: data['nombre'],
                            cantidad: 1,
                            precio: data['precio_venta'],
                            costo: data['precio_costo'],
                            descuento:0,
                            stock:data['stock']

                        }); 
                    }
            },

            /**************************************************************************************** */ 
            agregarClienteModal(data =[]){
                
                
                let me=this;


                                me.idcliente=data['id'];
                                me.nit = data['nit'];
                                me.nombrep = data['nombre'];
                                me.direccion = data['direccion'];
                                me.telefono = data['telefono'];
                this.cerrarModalB();
                    
            },
             /**************************************************************************************** */ 
            listarProducto (page,buscarA,criterioA,idlugar){
                let me=this;
                var url= '/existencia/listarProducto?page=' + page + '&buscar='+ buscarA + '&criterio='+ criterioA  + '&idlugar='+ idlugar;
                axios.get(url).then(function (response) {
                    var respuesta= response.data;
                    me.arrayProducto = respuesta.productos.data;
                    me.pagination2= respuesta.pagination2;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },


            pdfTraslado(id){
                
                 window.open(this.urlhttp+'/traslado/pdf/'+id+','+'_blank');
                
            },
         

           cotizacion(){



                  if (this.validarCotizacion()){
                    return;
                }


                Swal.fire({
                    title: 'Cotizacion a Nombre de:',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    showLoaderOnConfirm: true,
                    preConfirm: (login) => {

                        var f = new Date();
                        var fecha = (f.getDate() + "/" + (f.getMonth() +1) + "/" + f.getFullYear());

                         this.cotizar==1;
                
               const doc = new jsPDF();
                        doc.setFontSize(12);
                        doc.text("Titulos", 20, 5);
                         doc.setFontSize(7);
                        doc.text("DIRECCION:", 20, 8);
                         doc.setFontSize(7);
                        doc.text("TEL:", 20, 12);

                        

                        doc.setFontSize(10);
                        doc.text("Cotizacion a Nombre De: "+login,100,5);
                        doc.setFontSize(7);
                        doc.text("Fecha: "+fecha,185,5);
                        doc.addImage("img/mipueblitologo.png", "PNG", 5, 2, 10, 10);
                        doc.setFontSize(7);
                        doc.text("VIGENCIA DE COTIZACION Tiempo DESPUES DE SU EMISION",100,10);
                        
                        doc.autoTable({html: '#producto'});
                       
                       
                doc.save("cotizacion.pdf");
                        
                        this.cotizar==0;
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.fire({
                        title: `${result.value.login}'s avatar`,
                        imageUrl: result.value.avatar_url
                        })
                    }
                    })


           

           },

                 /**************************************************************************************** */ 
            listarCliente (buscarB,criterioB){
                 let me=this;
                var url= '/cliente/listarCliente?buscarB='+ buscarB + '&criterioB='+ criterioB;
               
                axios.get(url).then(function (response) {
                    var respuesta= response.data;
                    me.arrayCliente = respuesta.cliente.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
             /**************************************************************************************** */ 



            

            registrarTraslado(){

                // cambio= this.total - this.recibido;


               // validarUser();


                    if (this.validarTraslado()){
                    return;
                }
                   let me = this;

                if(me.idlugar===me.idlugar2){
                   Swal.fire({
                 icon: 'error',
                 title: 'Oops...',
                 text: 'El Destino No Puede Ser La Sucursal De Origen Del Traslado!',
                 
                  })
                    return;
                }
               
               // console.log(me.idlugar);
               // console.log(me.idlugar2);
             
                /*
                console.log(this.totalc);
                console.log(this.totalu);
                 console.log(this.recibido);
                */
                
                me.deshabilitar_boton=1;
            
                axios.post('/traslado/registrar',{
                    
                    'idlugar': this.idlugar,
                    'idlugar2': this.idlugar2,
                    'encargado': this.encargado,
                    'destinonombre': this.destinonombre,
                  

                    //'serie_comprobante' : this.serie_comprobante,
                    //'num_comprobante' : this.num_comprobante,
                    //'impuesto' : this.impuesto,
                    
                    'total' : this.total,
                    'data': this.arrayDetalle

                }).then(function (response) {
                    console.log(response);
                    me.listado=1;
                    me.listarTraslado(1,'','fecha_hora');
                    
                    me.idcliente=0;
                   
                    me.tipo_comprobante='TICKET';
                    //me.serie_comprobante='';
                    //me.num_comprobante='';
                    //me.impuesto=0.18;
                    me.total=0.0;
                    me.totalc=0.0;
                    me.totalu=0.0;
                    me.idproducto=0;
                    me.producto='';
                    me.cantidad=0;
                    me.costo=0;
                    me.precio=0;
                    me.descuento=0;
                    me.recibido=0;
                    me.arrayDetalle=[];
                    me.arrayCliente=[];
              
                     
                    
                     me.cerrarModal();
                     
                  
                     

                    Swal.fire({
                          position: 'top',
                          icon: 'success',
                          title: 'Datos Agregados Con Exito!',
                          showConfirmButton: false,
                          timer: 1000
                          
                        });

                        
                        
                     
                   me.deshabilitar_boton=0;
                    
                }).catch(function (error) {
                    console.log(error);
                });

            
            },

             /**************************************************************************************** */ 

            validarUser(){

               // window.location.href = '/logout';

/*
                axios.post('/user/activado',{
                    

                }).then(function (response) {
                    
                    console.log(response);
                  if(response){

                  }
                  else{

                        window.location.href = 'https://127.0.0.1:8000/logout';

                      

                  }
                     

                   
                    
                }).catch(function (error) {
                    console.log(error);
                });
*/
            },


            validarTraslado(){
                this.errorTraslado=0;
                this.errorMostrarMsjTraslado =[];

                //if (this.idcliente==0) this.errorMostrarMsjTraslado.push("Seleccione un Cliente");

               // if (this.idlugar==0) this.errorMostrarMsjTraslado.push("Seleccione un Origen");
                //if (this.idlugar2==0) this.errorMostrarMsjTraslado.push("Seleccione un Destino");

                if (this.idlugar2==0)this.errorMostrarMsjTraslado.push("Seleccione un Destino");

                if (this.idlugar2===this.lugar)this.errorMostrarMsjTraslado.push("No Puede seleccionar Como Destino Esta Sucursal")

                if(!this.encargado)this.errorMostrarMsjTraslado.push("Ingrese un Encargado");
                
                //if (this.tipo_comprobante==0) this.errorMostrarMsjTraslado.push("Seleccione el comprobante");
               // if (!this.num_comprobante) this.errorMostrarMsjTraslado.push("Ingrese el número de comprobante");
                //if (!this.impuesto) this.errorMostrarMsjTraslado.push("Ingrese el impuesto de traslado");
                if (this.arrayDetalle.length<=0) this.errorMostrarMsjTraslado.push("Ingrese detalles");

            /*
                if(this.recibido==0) {
                   this.errorMostrarMsjTraslado.push("El Monto recibido no puede ser 0");
                }

                if(this.cambio<0) {
                    this.errorMostrarMsjTraslado.push("El Cambio no puede ser Negativo");
                }

               */ 

                if (this.errorMostrarMsjTraslado.length) this.errorTraslado = 1;

                return this.errorTraslado;
            },


            
             /**************************************************************************************** */ 
            mostrarDetalle(){
                let me=this;
                me.listado=0;

                me.idcliente=0;
                me.nit='';
                me.nombre='';
                me.direccion='';
                me.telefono='';
                me.tipo_comprobante='TICKET';
                me.serie_comprobante='';
                me.numerotraslado='';
                me.encargado='';

                //me.impuesto=0.18;
                me.total=0.0;
                me.totalc=0.0;
                me.totalu=0.0;
                me.idproducto=0;
                me.producto='';
                me.cantidad=0;
                me.precio=0;
                me.arrayDetalle=[];
            },

             /**************************************************************************************** */ 
            ocultarDetalle(){
                this.listado=1;
            },

             /**************************************************************************************** */ 
            verTraslado(id){
                let me=this;
                me.listado=2;
                
                //Obtener los datos del traslado
                var arrayTrasladoT=[];
                var url= '/traslado/obtenerCabecera?id=' + id;
                
                axios.get(url).then(function (response) {
                    console.log();
                    var respuesta= response.data;
                    arrayTrasladoT = respuesta.traslado;

                    //me.cliente = arrayTrasladoT[0]['nombre'];
                    me.destino=arrayTrasladoT[0]['destino'];
                   // me.serie_comprobante=arrayTrasladoT[0]['serie_comprobante'];
                  //  me.num_comprobante=arrayTrasladoT[0]['num_comprobante'];
                  //  me.estado=arrayTrasladoT[0]['estado'];
                    //me.impuesto=arrayTrasladoT[0]['impuesto'];
                   
                    me.total=arrayTrasladoT[0]['total'];
                   // me.totalc=arrayTrasladoT[0]['totalc'];
                   // me.totalu=arrayTrasladoT[0]['totalu'];
                   
                })
                .catch(function (error) {
                    console.log(error);
                });

                //Obtener los datos de los detalles 
                var urld= '/traslado/obtenerDetalles?id=' + id;
                
                axios.get(urld).then(function (response) {
                    //console.log(response);
                    var respuesta= response.data;
                    me.arrayDetalle = respuesta.detalles;
                })
                .catch(function (error) {
                    console.log(error);
                });               
            },

             /**************************************************************************************** */ 
            cerrarModal(){
                this.modal=0;
                this.tituloModal='';
                this.modal2=0;
                this.recibido='';
                this.cambio='';
                this.desbloquear=0;
                this.deshabilitar_boton==0;

                 
            }, 

             /**************************************************************************************** */ 
            abrirModal(){               
                this.arrayProducto=[];
                this.modal = 1;
                this.tituloModal = 'Seleccione uno o varios productos';
            },


             abrirModalAlarma(modelo2, accion, data = []){
              switch(modelo2){
                    case "producto":
                    {
                      switch(accion){
                        case 'alarma':
                            {
                              this.modal2=1;
                              this.tituloModal2='Stock Minimo';
                              break;
                            }
                      } 
                    } 
              }

            },

            selectLugar(){
                let me=this;
                var url= '/lugar/selectLugar';
                axios.get(url).then(function (response) {
                   // console.log(response);
                    var respuesta= response.data;
                    me.arrayLugar = respuesta.lugares;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            selectLugar2(){
                let me=this;
                var url= '/lugar/selectLugar';
                axios.get(url).then(function (response) {
                   // console.log(response);
                    var respuesta= response.data;
                    me.arrayLugar2 = respuesta.lugares;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },


             /**************************************************************************************** */ 
             /*
            desactivarTraslado(id){
               swal.fire({
                title: 'Esta seguro de anular este traslado?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
                }).then((result) => {
                if (result.value) {
                    let me = this;

                    axios.put('/traslado/desactivar',{
                        'id': id
                    }).then(function (response) {
                        me.listarTraslado(1,'','tipo_comprobante');
                        swal.fire(
                        'Anulado!',
                        'El traslado ha sido anulado con éxito.',
                        'success'
                        )
                    }).catch(function (error) {
                        console.log(error);
                    });
                    
                    
                } else if (
                    // Read more about handling dismissals
                    result.dismiss === swal.DismissReason.cancel
                ) {
                    
                }
                }) 
            },
*/

/*
             desactivarTraslado(id,num_comprobante,total){

                 let lugar2 = this.idlugar2
                 
                
              Swal.fire({
                title: 'Esta seguro/a que desea Anular esta Traslado?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                  
                if (result.value) {
                  let me = this;
                  var arrayTrasladoT=[];
                        axios.put('/traslado/desactivar',{
                          'id': id,
                          'num_comprobante':num_comprobante,
                          'total':total,
                          'lugar2': lugar2

                        }).then(function(response){
                            
                          me.listarTraslado(1,'','fecha_hora',me.idlugar2);
                        
                          Swal.fire(
                            'Anulado!',
                            'El registro a sido desactivado con exito.',
                            'success'
                          )
                        }).catch(function(error){
                          console.log(error);
                        });

                  
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                 
                }
              })
              
                },
/*
         eliminarArticulo(id,cantidad,precio,descuento,idtraslado,idproducto,producto){

                let me = this;

                let numV = document.getElementById("numTraslado").innerHTML;
                let totav = document.getElementById("totalTrasladoArticulo").innerHTML;
               let estado = document.getElementById("estado").innerHTML;
               let resta = precio*cantidad-descuento;
               let restaTotal =  totav - resta;


                 if(estado=='Registrado'){

                     console.log('Dentro');

                     Swal.fire({
                title: 'Esta seguro/a que desea Anular este Articulo?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                if (result.value) {
                  let me = this;
                  var arrayTrasladoT=[];
                        axios.put('/traslado/earticulo',{
                          'id': id,
                          'idtraslado':idtraslado,
                          'idproducto':idproducto,
                          'producto':producto,
                          'numV':numV,
                          'cantidad':cantidad,
                          'resta':resta,
                          'restaTotal':restaTotal

                          
                          

                        }).then(function(response){
                          me.listarTraslado(1,'','fecha_hora',idlugar2);
                        
                          Swal.fire(
                            'Anulado!',
                            'El registro a sido desactivado con exito.',
                            'success'
                          )
                          console.log(response);
                           me.verTraslado(idtraslado);
                          
                        }).catch(function(error){
                          console.log(error);
                        });

                  
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                 
                }
              })


                 } else{

                     Swal.fire({
                        icon: 'error',
                        title: 'Ya Esta Anulada...',
                        text: 'La Totalidad de esta Traslado ya Esta Anulada!'
                       
                        })
                 }
                 
                
            
              console.log('NumeroV:'+numV);
              console.log('Nombre:'+producto);
              console.log('totaldetraslado:'+totav);
               
                console.log('cantidad:'+cantidad);
                console.log('Precio:'+precio);
                console.log('Descuento:'+descuento);
               console.log('subtotal:'+resta);
                console.log('total-subtotal:'+restaTotal);
              
               
            }, 

*/

         /**************************************************************************************** */ 

          
            
                 cerrarModalB(){
                this.modalB=0;
                this.tituloModalB='';
            }, 
            abrirModalB(){               
                this.arrayCliente=[];
                this.modalB = 1;
                this.tituloModalB = 'Seleccione el cliente';
            },

             mostrarDetalle(){
                let me=this;
                me.listado=0;

                me.idcliente=0;
                me.nombre='';
                me.direccion='';
                me.telefono='';
                me.tipo_comprobante='TICKET';
                me.serie_comprobante='';
                me.num_comprobante='';
                //me.impuesto=0.18;
                me.total=0.0;
                me.totalc=0.0;
                me.totalu=0.0;
                me.idproducto=0;
                me.producto='';
                me.cantidad=0;
                me.precio=0;
                me.costo=0;
                me.arrayDetalle=[];
            },
            ocultarDetalle(){
                this.listado=1;
            },

            


        agregarETraslado(id,numerotraslado,total){

                    let me = this;
                
                 
                
                 var urld= '/traslado/obtenerDetalles?id=' + id +'&numerotraslado='+numerotraslado;
                
                axios.get(urld).then(function (response) {
                    console.log(response);
                    var respuesta= response.data;
                    me.arrayAceptarT = respuesta.detalles;
                    
                   
                  
                })
                .catch(function (error) {
                    console.log(error);
                });  
             
             this.detallelistraslado(id,numerotraslado,total);

        },

        detallelistraslado(id,numerotraslado,total){



            Swal.fire({
                title: 'Esta seguro/a que desea Aceptar este Traslado?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {

                  
                if (result.value) {
                  let me = this;
                  
             
                     
                axios.put('/traslado/aceptado',{
                          'id': id,
                          'numerotraslado':numerotraslado,
                          'total':total,
                          'lugar': me.lugar,
                          'data': me.arrayAceptarT
                          

                        }).then(function(response){
                          //  console.log(response);
                          me.listarTraslado(1,'','fecha_hora',);
                          me.arrayAceptarT=[];
                          Swal.fire(
                            'Anulado!',
                            'El registro a sido desactivado con exito.',
                            'success'
                          )
                        }).catch(function(error){
                          console.log(error);
                        });
                        
                 // console.log(this.arrayAnularV);
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                 
                }
              })


           },

           listarUser(){
           
             let me=this;
                var url= '/lugar/sucursal';
                axios.post(url).then(function (response) {
                    //console.log(response);
                    var respuesta= response.data;
                    me.arraySucursal = respuesta.sucursal;

                     if(me.arraySucursal.length>0){

                        
                        
                       me.nombreUsuario=me.arraySucursal[0]["nombre"];
                       me.nombreSucursal=me.arraySucursal[0]["nombresucursal"];
                        me.direccionSucursal=me.arraySucursal[0]["direccion"];
                        me.idlugar=me.arraySucursal[0]["idlugar"];
                       

                       
                    // console.log(me.nombreUsuario);
                        
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        
        
        },

        },
        mounted() {
            
            this.listarTraslado(1,this.buscar,this.criterio);
           // this.selectLugar();
            this.selectLugar2();
            this.listarUser();
        
            
        }
    }
</script>
<style>    
    .modal-content{
        width: 100% !important;
        position: absolute !important;
    }
    .mostrar{
        display: list-item !important;
        opacity: 1 !important;
        position: absolute !important;
        background-color: #3c29297a !important;
    }
    .div-error{
        display: flex;
        justify-content: center;
    }
    .text-error{
        color: red !important;
        font-weight: bold;
    }
    @media (min-width: 600px) {
        .btnagregar {
            margin-top: 2rem;
        }
    }

</style>
